/*
 * Copyright (c) 2019 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

export default class FilterPersistenceService {

    static $inject = [];

    private persistedData: Map<string, any> = new Map<string, string>();

    /* @ngInject */
    constructor() {
    }

    public persistFilter(namespace: string, filter: any) {
        this.persistedData.set(namespace, filter);

    }

    public restoreFilter(namespace: string): any {
        return this.persistedData.get(namespace);
    }

    /**
     * Deletes the given namespace from the list if it exists and returns true.
     * If it doesn't exist it returns false
     */
    public deleteFilter(namespace: string): void {
        this.persistedData.delete(namespace);
    }

    public clearAll(): void {
        this.persistedData = new Map<string, any>();
    }

}



// WEBPACK FOOTER //
// ./src/app/core/service/FilterPersistenceService.ts